export const FETCH_FEEDS = 'FETCH_FEEDS';
export const REQUEST_FEEDS = 'REQUEST_FEEDS';
export const RECEIVE_FEEDS = 'RECEIVE_FEEDS';
export const REJECT_FEEDS = 'REJECT_FEEDS';